var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarExpand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.28125 2.71875L10.5625 5H5C4.4375 5 4 5.46875 4 6C4 6.5625 4.4375 7 5 7H10.5625L8.28125 9.3125C8.09375 9.5 8 9.75 8 10C8 10.2812 8.09375 10.5312 8.28125 10.7188C8.65625 11.125 9.3125 11.125 9.6875 10.7188L13.6875 6.71875C14.0938 6.34375 14.0938 5.6875 13.6875 5.3125L9.6875 1.3125C9.3125 0.90625 8.65625 0.90625 8.28125 1.3125C7.875 1.6875 7.875 2.34375 8.28125 2.71875ZM2 11V1C2 0.46875 1.53125 0 1 0C0.4375 0 0 0.46875 0 1V11C0 11.5625 0.4375 12 1 12C1.53125 12 2 11.5625 2 11Z",
    fill: "#193154"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarExpand);
export default __webpack_public_path__ + "static/media/sidebar_expand.81244317784a8373b0d4c6e58c8a0723.svg";
export { ForwardRef as ReactComponent };